/* import __COLOCATED_TEMPLATE__ from './card-filter.hbs'; */
var _class;
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import Component from '@glimmer/component';
import { action } from '@ember/object';
let CardFilter = (_class = class CardFilter extends Component {
  get actualCards() {
    return this.args.cardCategories.filter(c => c.cardToken);
  }

  // Enriched card list with disabled flag for the template
  get cardItems() {
    const {
      selectedCards
    } = this.args;
    const actualCards = this.actualCards;
    const isLastSelected = selectedCards.length === 1;
    return actualCards.map(card => ({
      card,
      disabled: isLastSelected && selectedCards[0].cardToken === card.cardToken
    }));
  }

  // Controls which rows appear selected in the market-list
  get selectedValues() {
    const {
      selectedCards
    } = this.args;
    const actualCards = this.actualCards;

    // No selection or all selected = check all rows
    if (selectedCards.length === 0 || selectedCards.length === actualCards.length) {
      return actualCards.map(c => c.cardToken).join(',');
    }
    return selectedCards.map(c => c.cardToken).filter(Boolean).join(',');
  }

  // Button label: single card name
  get displayValue() {
    const {
      selectedCards
    } = this.args;
    if (selectedCards.length === 1) {
      return selectedCards[0].label;
    }
    return null;
  }

  // Button label: "X cards" for partial multi-select
  get isMultipleSelected() {
    const {
      selectedCards
    } = this.args;
    const actualCards = this.actualCards;
    return selectedCards.length > 1 && selectedCards.length < actualCards.length;
  }

  // Button label: "All cards" when none or all selected
  get showAllCardsLabel() {
    const {
      selectedCards
    } = this.args;
    const actualCards = this.actualCards;
    return selectedCards.length === 0 || selectedCards.length === actualCards.length;
  }
  onSelectionsChange(event) {
    const {
      newSelectionValue,
      newDeselectionValue
    } = event.detail;
    const actualCards = this.actualCards;
    const {
      selectedCards
    } = this.args;

    // Handle individual card selection
    if (newSelectionValue) {
      const card = actualCards.find(c => c.cardToken === newSelectionValue);
      if (card) {
        this.args.cardFilterChanged([...selectedCards, card]);
      }
      return;
    }

    // Handle individual card deselection
    if (newDeselectionValue) {
      // "All cards" state (empty = all): deselect one → select all except that one
      if (selectedCards.length === 0) {
        const newSelectedCards = actualCards.filter(c => c.cardToken !== newDeselectionValue);
        this.args.cardFilterChanged(newSelectedCards);
        return;
      }

      // Last card is disabled in the template, but guard here as a safety net
      if (selectedCards.length === 1) {
        return;
      }
      const newSelectedCards = selectedCards.filter(c => c.cardToken !== newDeselectionValue);
      this.args.cardFilterChanged(newSelectedCards);
    }
  }
}, _applyDecoratedDescriptor(_class.prototype, "onSelectionsChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onSelectionsChange"), _class.prototype), _class);
export { CardFilter as default };